<template>
  <div>
    <v-tooltip open-delay="500" top>
      <template #activator="{ on, attrs }">
        <v-btn :disabled="disabled" x-small icon v-bind="attrs" v-on="on" @click.stop="mudarEstadoDialog">
          <v-icon small v-text="'mdi-information-outline'" />
        </v-btn>
      </template>
      <span>Detalhamento dos pedidos de compra pendentes</span>
    </v-tooltip>

    <v-dialog
      v-model="dialog_ativo"
      width="1200"
      content-class="bra-20"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-card-title>
          <span>Pedidos pendentes</span>
          <v-spacer />

          <v-btn icon>
            <v-icon @click.stop="mudarEstadoDialog">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-data-table
            height="400px"
            :headers="headers"
            :items="items"
            class="table-full-screen tabela-azul-compra-por-departamento"
            :items-per-page="-1"
            hide-default-footer
            fixed-header
          >
            <template v-slot:top>
              <slot name="topo-tabela" />
            </template>

            <template #body.prepend>
              <tr class="font-weight-bold">
                <td>TOTALIZADOR</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>{{ Helpers.formatarValor(TOTALIZADOR_ITENS.qtde) }}</td>
                <td>{{ Helpers.formatarValor(TOTALIZADOR_ITENS.qtde_pendente) }}</td>
                <td>{{ Helpers.formatarValor(TOTALIZADOR_ITENS.qtde_entregue) }}</td>
                <td>-</td>
              </tr>
            </template>

            <template v-slot:item.pcompra="{item}">
              {{Helpers.formatarValorComCasas(item.pcompra, 4)}}
            </template>

            <template v-slot:item.qtde="{item}">
              {{Helpers.formatarValor(item.qtde)}}
            </template>

            <template v-slot:item.qtde_pendente="{item}">
              {{Helpers.formatarValor(item.qtde_pendente)}}
            </template>

            <template v-slot:item.qtde_entregue="{item}">
              {{Helpers.formatarValor(item.qtde_entregue)}}
            </template>

            <template v-slot:item.qtde_entregue="{item}">
              {{Helpers.formatarValor(item.qtde_entregue)}}
            </template>

            <template v-slot:item.data_entrega="{item}">
              <span v-if="item.data_entrega">{{ item.data_entrega }}</span>
              <span v-else class="text-gray-300">Sem Entrega</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RequisicaoAPI from "../../../../api/Requisicao";
import {logout} from "../../../../helpers";

export default {
  name: "PedidosPendente",
  props: {
    filtros: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    dialog_ativo: false,
    headers: [
      {text: 'Produto', value: 'produto'},
      {text: 'Id da Solicitação', value: 'id_solicitacao'},
      {text: 'Data da Solicitação', value: 'data_solicitacao'},
      {text: 'Ordem de Compra', value: 'ordem_compra'},
      {text: 'Filial', value: 'idfilial'},
      {text: 'Item', value: 'item'},
      {text: 'Preço de Compra', value: 'pcompra'},
      {text: 'Unidade de Medida', value: 'unidade_medida'},
      {text: 'Qtde. Comprada', value: 'qtde'},
      {text: 'Qtde. Pendente', value: 'qtde_pendente'},
      {text: 'Qtde. Entregue', value: 'qtde_entregue'},
      {text: 'Data da Últ. Entrega', value: 'data_entrega'},
    ],
    items: []
  }),
  computed: {
    TOTALIZADOR_ITENS() {
      const callback = (a, b) => {
        return {
          qtde: Number(a.qtde) + Number(b.qtde),
          qtde_pendente: Number(a.qtde_pendente) + Number(b.qtde_pendente),
          qtde_entregue: Number(a.qtde_entregue) + Number(b.qtde_entregue)
        };
      };

      const obg_padrao = {
        qtde: 0,
        qtde_pendente: 0,
        qtde_entregue: 0,
      };

      return  this.items.reduce(callback, obg_padrao);
    }
  },
  methods: {
    mudarEstadoDialog() {
      this.dialog_ativo = !this.dialog_ativo;

      if (this.dialog_ativo) {
        this.items = [];
        this.getPedidosEmAberto();
      }
    },
    getPedidosEmAberto() {
      const parametros = {
        grupo: this.filtros.grupo,
        iddepartamento: this.filtros.iddepartamento,
        idsecao: this.filtros.idsecao,
        idcategoria: this.filtros.idcategoria,
        idproduto: this.filtros.idproduto
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        RequisicaoAPI.getRequisicaoDepartamento(parametros)
          .then(resp => {
            const {token, requisicoes} = resp.data
            localStorage.token = token
            this.items = requisicoes;
          })
          .catch(logout)
      );
    }
  }
}
</script>
